import InlineLoading from './component.jsx'
export default InlineLoading
